var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnNavPortfolioInactive = function SvgEarnNavPortfolioInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.286 4.438A10.78 10.78 0 1 0 24.06 15.214H13.286V4.438Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.286 3.114v12.1h12.1A1.115 1.115 0 0 0 26.496 14 13.27 13.27 0 0 0 14.5 2.004a1.114 1.114 0 0 0-1.215 1.11ZM13.286 25.995a10.781 10.781 0 0 0 10.776-10.78H13.286v10.78Z",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.528 14.55a.454.454 0 0 1-.44-.3.45.45 0 0 1 .415-.595.44.44 0 0 1 .355.175.656.656 0 0 0 .5.27h.08a.64.64 0 0 0 .55-1 1.839 1.839 0 0 0-.65-.59.34.34 0 0 1-.175-.29.67.67 0 0 0-.66-.65.67.67 0 0 0-.67.67.32.32 0 0 1-.17.285 1.784 1.784 0 0 0 .84 3.359.445.445 0 1 1-.146.866.46.46 0 0 1-.224-.161.6.6 0 0 0-.5-.26h-.08a.659.659 0 0 0-.53 1.05c.164.207.37.378.605.5a.32.32 0 0 1 .17.284.67.67 0 0 0 .705.7.67.67 0 0 0 .67-.67.32.32 0 0 1 .17-.285 1.785 1.785 0 0 0-.815-3.359ZM26.496 14a13.225 13.225 0 0 0-3.829-8.157l-9.38 9.371h12.1A1.116 1.116 0 0 0 26.495 14Z",
    fill: "#E5E5E5"
  })));
};
export default SvgEarnNavPortfolioInactive;